import { Feature } from 'flagged';

import type { SideMenuItemElement } from '@constants/constants';

export const renderMenuItems = (
  items: SideMenuItemElement[],
  renderItem: (item: SideMenuItemElement) => React.ReactElement
) => {
  return items?.map((item) => (
    <Feature
      key={item.label}
      name={item.feature}
      render={(isEnabled: boolean) => (isEnabled ? renderItem(item) : <></>)}
    />
  ));
};

// ====================================
// Get the redirection url after logout
// ====================================
export const getLogoutRedirectionURL = (
  targetPathname: string,
  currentPathname: string
) => {
  if (
    targetPathname === '/logout' &&
    (currentPathname.includes('profil') ||
      currentPathname.includes('seyahat-planlama') ||
      currentPathname.includes('rezervasyon-bilgileri'))
  ) {
    return '/';
  }

  return targetPathname === '/logout'
    ? `${window.location.pathname}${window.location.search}`
    : targetPathname;
};
